import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import OperatorTable from '../OperatorTable'
import { ColumnDef } from '@tanstack/react-table'
import { buttonVariants } from '@/common/ui/button'
import { cn } from '@/common/lib/utils'
import { Link } from 'react-router-dom'
import { Plus } from 'lucide-react'
import { OperatorDataResponse } from '../../types'

interface OperatorListProps {
	data: OperatorDataResponse[]
	total: number
	columns: ColumnDef<OperatorDataResponse>[]
}

export default function OperatorListing({
	data,
	total,
	columns,
}: OperatorListProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title="รายชื่อ operator"
					description="รายชื่อ operator ทั้งหมด"
				/>

				<Link
					to={'/admin/create-operator'}
					className={cn(buttonVariants({ variant: 'default' }))}
				>
					<Plus className="mr-2 h-4 w-4" /> สร้าง operator
				</Link>
			</div>
			<Separator />
			<OperatorTable data={data} total={total} columns={columns} />
		</div>
	)
}
